<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <force-change-pwd-dialog />
    <!-- <theme-picker /> -->
  </div>
</template>

<script>
// import ThemePicker from "@/components/ThemePicker";
import ForceChangePwdDialog from "@/components/ForceChangePwdDialog";
import router from './router';
import store from './store';
import { getToken } from '@/utils/auth'
export default {
  name: "App",
  components: { ForceChangePwdDialog },
    metaInfo() {
        return {
            // title: this.$store.state.settings.dynamicTitle && this.$store.state.settings.title,
            // titleTemplate: title => {
            //     return title ? `${title} - ${process.env.VUE_APP_TITLE}` : process.env.VUE_APP_TITLE
            // }
        }
    },
    mounted(){
      if(getToken()){
        store.dispatch('GenerateRoutes').then(accessRoutes => {
            console.log("accessRoutes",accessRoutes)
            // 根据roles权限生成可访问的路由表
            router.addRoutes(accessRoutes) // 动态添加可访问路由表
        })
      }
    },
};
</script>
<style>
#app .theme-picker {
  display: none;
}
wujie-app {
    z-index: 1500;
    position: relative; /* 或者 relative，如果不需要该元素浮动 */
    overflow: visible; /* 确保子元素不会被隐藏 */
    /* pointer-events: none; */
}
::-webkit-scrollbar {
	width: 6px;
}
::-webkit-scrollbar-track{
	background: #dbdbdb;
	border-radius: 3px;
}
::-webkit-scrollbar-thumb {
	background: #b1b0b3;
	border-radius: 3px;
}
</style>
